import { Badge } from '@heidi/design-system/badge';
import { Evidence } from '@heidi/design-system/icons';
import { useIntl } from 'react-intl';

import { workingBlockMessages } from '../../../../../data/projects/timeline/working-block/workingBlock.messages';

/**
 * Attributes a step to the Evidence sub-agent. An identity rather than a
 * status, so it wears Evidence's entity blue, not a validation tone.
 */
export const EvidenceBadge = (): JSX.Element => {
  const intl = useIntl();
  return (
    <Badge color="blue" size="sm" className="shrink-0 gap-1 rounded-md font-medium">
      <Evidence aria-hidden />
      {intl.formatMessage(workingBlockMessages.evidenceBadge)}
    </Badge>
  );
};
